"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSuchBucket = {
    type: "structure",
    required: [],
    members: {},
    exceptionType: "NoSuchBucket"
};
//# sourceMappingURL=NoSuchBucket.js.map